import ReactDOM from 'react-dom'

const CreatePortalModal = ({children, elementId}) => {
  const modalRoot = document.getElementById(elementId)
  return ReactDOM.createPortal(children, modalRoot)
}

export default CreatePortalModal
